import React from "react";
import { Fragment } from "react";
import { Chip } from "@mui/joy";
import Divider from "@mui/joy/Divider";
import EventLeaderBoardTable from "../../Tables/EventLeaderBoardTable";

const EventLeaderBoardSection = ({ data }: any) => {
  return (
    <Fragment>
      <div className="pt-4"></div>
      <EventLeaderBoardTable eventname={data.eventname} />
      <div className="pt-4"></div>
    </Fragment>
  );
};

export default EventLeaderBoardSection;